var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1794_53535)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#003845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7819 13.4718C24.4158 13.2849 24.0342 13.1291 23.6369 12.9967V22.3669C22.749 22.0475 21.8377 21.884 20.9108 21.884C19.4308 21.884 18.9077 22.3046 17.568 23.1146V13.6899C16.3061 12.9655 14.8496 12.5371 13.284 12.5371C11.8897 12.5371 10.5734 12.8798 9.41282 13.4718C9.15578 13.5964 9 13.869 9 14.1572V23.5664C9 24.0182 9.36609 24.3375 9.77891 24.3375C9.90353 24.3375 10.0282 24.3064 10.1528 24.2441C11.0953 23.7533 12.1546 23.4418 13.284 23.4418C14.8963 23.4418 16.384 24.0805 17.568 24.9996C18.7519 24.0805 19.2984 23.4418 20.9108 23.4418C22.0402 23.4418 23.0995 23.7533 24.042 24.2518C24.1666 24.3142 24.2912 24.3453 24.4158 24.3453C24.8209 24.3453 25.1947 24.026 25.1947 23.5742V14.1572C25.1947 13.869 25.039 13.5964 24.7819 13.4718ZM16.0101 22.3669C15.1222 22.0475 14.2109 21.884 13.284 21.884C12.3571 21.884 11.4458 22.0475 10.5578 22.3669V14.6479C11.4224 14.2819 12.3337 14.0949 13.284 14.0949C14.2187 14.0949 15.1456 14.2896 16.0101 14.6557V22.3669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.936 11.1491L24.4656 10.6194C24.7019 10.3831 24.7019 9.99203 24.4656 9.75573L23.8871 9.17722C23.6508 8.94093 23.2597 8.94093 23.0234 9.17722L22.4938 9.70685L23.936 11.1491ZM23.4553 11.6298L19.8538 15.2312H18.4116V13.789L22.0131 10.1876L23.4553 11.6298Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1794_53535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.f9d11bf7b005b4f54872d16a11f7c4a7.svg";
export { ForwardRef as ReactComponent };